import { Cache } from 'aws-amplify';

import { CoconutType } from './coconutType';

export const MutationResponseFields = ['id', 'type', 'owner'];

export const CommonFields = ['id', 'type', 'owner', 'createdBy', 'updatedBy', 'createdAt', 'updatedAt'];

export const RetailFields = [
  ...CommonFields,
  'firstName',
  'middleName',
  'lastName',
  'phoneCountryCode',
  'phone',
  'profilePhoto',
  'phoneNumberVerified',
  'smsActivityNotificationsEnabled',
  'emailMarketingNotificationsEnabled',
  'emailTransferStatusNotificationsEnabled',
  'smsTransferStatusNotificationsEnabled',
  'opportunityLost',
  'mfaReminderEnabled',
  'mfaEnabled',
  'email',
  'isAutoRegistered',
  'streetAddress',
  'streetAddressUnitNumber',
  'streetAddressNumber',
  'streetAddressName',
  'streetAddressType',
  'city',
  'state',
  'postcode',
  'country',
  'birthDate',
  'birthDateString',
  'countryOfBirth',
  'currencyFrom',
  'currencyTo',
  'countryFrom',
  'countryTo',
  'estimatedValue',
  'purpose',
  'otherPurpose',
  'fundsFromCustomer',
  'fundsGoingtoDiffPerson',
  'frequency',
  'affiliateId',
  'trackingId',
  'kycRequest',
  'kycResponse',
  'otherSource',
  'sendId',
  'cxManager',
  'accountManager',
  'currencyCloudId',
  'currencyCloudContactId',
  'currencyCloudReference',
  'kycScore',
  'kycProvider',
  'complianceScore',
  'riskDetails',
  'status',
  'dealing',
  'termsAccepted',
  'leadId',
  'unread',
  'authorityFirstName',
  'authorityMiddleName',
  'authorityLastName',
  'authorityEmail',
  'authorityPhoneCountryCode',
  'authorityPhone',
  'registrationDate',
  'failedPepSanctionsCheck',
  'pricingPlanId',
  'proposedTradingDate',
  'proposedMovingDate',
  // for portal
  'docExpiryDate',
  'docExpiryDateString',
  'docIssuingCountry',
  'docRegion',
  'docId',
  'docCardNumber',
  'docType',
  'docLicenceVersion',
  'balances',
  'manualSendTempPassword',
  'manualSendDocumentsNeededEmail',
  'portalSource',
  'affiliateEmployee',
  'affiliateBranch',
  'affiliateEmployeeEmail',
  'affiliateEmployeeId',
  'isCreatedWithoutLead',
  'error',
  'manualConvertRegistration',
  'lastNoteAddedTime',
  'addressNotValidated',

  'payInBSB',
  'payInAccNo',
  'payInABAStatus',
  'payInAccountName',
  'payInPayIdAlias',
  'payInPayIdStatus',
  'payInPayIdName',
  'payInBPayCRN',
  'payInBPayBillerCode',

  // for Trusted-api
  'registrationSource',
  'createdSource',
  'adviserName',
  'adviserEmail',
  'adviserPhoneCountryCode',
  'adviserPhone',
  // for social login
  'loginSource',
  //for auto overrides
  'regOverrideFields',
  // for Finance
  'financeAccount',
  //lead stuff
  'leadConfidence',
  'confirmedTradeAmount',
  'nextTaskDueDate',
  //Registration Boomerang
  'registrationBoomerangReason',
  'vrnLegalAcknowledgement',
  //expected margin
  'expectedMargin',
  'immediateTransfer',
  // pexa optin
  'pexaOptInValidated',
  'pexaOptInAt',
];

export const CorporateFields = [
  ...RetailFields,
  'businessName',
  'registrationNumber',
  'businessType',
  'industry',
  'website',
  'corporateStreetAddress',
  'corporateStreetUnitNumber',
  'corporateStreetNumber',
  'corporateStreetName',
  'corporateStreetType',
  'corporateCity',
  'corporateState',
  'corporatePostcode',
  'corporateCountry',
  'businessRole',
  'businessRepConfirmed',
  'complexBusinessStructure',
  'businessOperatingYear',
  'beneficiariesOfTrust',
  'directors',
  'webhookSecret',
  'transactionalApiWebhookUrls',
  'transactionalAPIRegistration',
  'eburyRegistration',
  'eburyNumber',
  'activeCurrencies',
  'apiOrganisationType',
  'frankieUboRequestId',
  'frankieUboEntityId',
  'corporatePurposes',
  'doesNotUseWebsite',
  'marketingDescription',
  'businessHasTrust',
  'otherBusinessRole',
  'originalRegistrationId',
];

export const TrustedAPIRegistrationFields = [
  ...RetailFields,
  'businessName',
  'registrationNumber',
  'businessType',
  'industry',
  'website',
  'corporateStreetAddress',
  'corporateStreetUnitNumber',
  'corporateStreetNumber',
  'corporateStreetName',
  'corporateStreetType',
  'corporateCity',
  'corporateState',
  'corporatePostcode',
  'corporateCountry',
  'businessRole',
  'businessRepConfirmed',
  'complexBusinessStructure',
  'businessOperatingYear',
];

export const TrustedAPIQuoteFields = [
  ...CommonFields,
  'clientRate',
  'coreRate',
  'conversionDate',
  'sellCurrency',
  'bookedSellAmount',
  'buyCurrency',
  'bookedBuyAmount',
  'margin',
  'expireTime',
  'documentsRequired',
  'createdSource',
  'commission',
];

export const TransactionalAPIQuoteFields = [
  ...CommonFields,
  'clientRate',
  'coreRate',
  'conversionDate',
  'sellCurrency',
  'bookedSellAmount',
  'buyCurrency',
  'bookedBuyAmount',
  'margin',
  'expireTime',
  'documentsRequired',
  'createdSource',
  'commission',
];

export const BeneficiaryFields = [
  ...CommonFields,
  'beneficiaryBankAccountCountry',
  'currencyTo',
  'isAutoVerified',
  'beneficiaryType',
  'businessName',
  'firstName',
  'middleName',
  'lastName',
  'phone',
  'phoneCountryCode',
  'email',
  'streetAddress',
  'streetAddressUnitNumber',
  'streetAddressNumber',
  'streetAddressName',
  'streetAddressType',
  'city',
  'state',
  'postcode',
  'country',
  'bicSwiftCode',
  'bsbCode',
  'iban',
  'sortCodeNumber',
  'clabeNumber',
  'cnapsNumber',
  'abaCode',
  'bankName',
  'bankCode',
  'deactivateReason',
  'accountNumber',
  'ifscNumber',
  'status',
  'currencyCloudId',
  'kycScore',
  'kycProvider',
  'complianceScore',
  'riskDetails',
  'inCurrencyCloud',
  'beneVerified',
  'parentId',
  'parentType',
  'birthDate',
  'birthDateString',
  'unread',
  'error',
  'createdSource',
  'paymentType',
  'beneOverrideFields',
  'financeAccount',
  'addressNotValidated',
];

export const LeadFields = [
  ...CommonFields,
  'lastContact',
  'firstName',
  'middleName',
  'lastName',
  'phone',
  'phoneCountryCode',
  'email',
  'currencyFrom',
  'currencyTo',
  'countryFrom',
  'countryTo',
  'estimatedValue',
  'purpose',
  'otherPurpose',
  'affiliateId',
  'otherSource',
  'trackingId',
  'cxManager',
  'status',
  'unqualifiedReason',
  'qualifiedDate',
  'unread',
  'affiliateEmployee',
  'affiliateEmployeeEmail',
  'affiliateEmployeeId',
  'affiliateBranch',
  'isCreatedFromReg',
  'accountManager',
  'proposedTradingDate',
  'proposedMovingDate',
  'state',
  'country',
  'leadConfidence',
  'nextTaskDueDate',
  'confirmedTradeAmount',
  'expectedMargin',
  'immediateTransfer',
  'metadata',
];

export const RegistrationFields = [...CorporateFields, ...LeadFields];

export const NoteFields = [...CommonFields, 'description', 'parentId', 'parentType', 'status'];

export const SMRFields = [...CommonFields, 'description', 'parentId', 'parentType', 'status', 'customerName'];

export const NotificationFields = [...CommonFields, 'description', 'parentId', 'parentType', 'status', 'notificationType'];

export const ComplianceNoteFields = [
  ...CommonFields,
  'description',
  'parentId',
  'parentType',
  'status',
  'decisionMade',
  'decisionVerified',
  'furtherAction',
  'completed',
  'complianceEvent',
  'isComplianceCheckList',
  'completedAt',
  'customerName',
  'sendId',
  'assignee',
  'verifiedBy',
];

export const TaskFields = [
  ...CommonFields,
  'title',
  'description',
  'dueDate',
  'assignee',
  'completed',
  'parentId',
  'parentType',
  'customerName',
  'status',
];

export const RateAlertFields = [
  ...CommonFields,
  'currencyFrom',
  'currencyTo',
  'customerDefaultPricingPlanId',
  'pricingPlanId',
  'clientRate',
  'targetRate',
  'amount',
  'accountManagerPhoneNumber',
  'canSendAccountManagerRateAlert',
  'accountManagerRateAlertEmailSent',
  'status',
  'completed',
  'parentId',
  'parentType',
  'customerName',
  'customerEmail',
  'assignee',
];

export const DocumentFields = [
  ...CommonFields,
  'docShortId',
  'docType',
  'docInstructions',
  'docRequestedDate',
  'docRequestedBy',
  'docUploadedDate',
  'docUploadedBy',
  'docExpiryDate',
  'docExpiryDateString',
  'docIssuingCountry',
  'docTag',
  'docStatus',
  'docAssessmentDate',
  'docAssessmentBy',
  'docKey',
  'docKeys',
  'showToClient',
  'docId',
  'docCardNumber',
  'docNotApprovedReason',
  'userId',
  'parentId',
  'parentType',
  'docRegion',
  'docSubType',
  'docRequestType',
  'docLicenceVersion',
  'customerNotificationCreated',
  'accountManager',
  'firstName',
  'lastName',
  'businessName',
  'secondParentId', // regId
  'secondParentType', // regType
];

export const LookupFields = [...CommonFields, 'lookupType', 'lookupValue'];

export const SettingFields = [
  ...CommonFields,
  'features',
  'affiliates',
  'features',
  'unqualifiedReasons',
  'transferPurposes',
  'transferAmounts',
  'countries',
  'currencies',
  'pricingPlanBankRateComparison',
  'pricingPlanBankSendingFee',
  'customerDailyTradeLimit',
  'highRiskCustomerDailyTradeLimit',
  'customerMinTradeValue',
  'blacklistedCurrencies',
  'poaDocInstructions',
  'poiPhotoDocInstructions',
  'poiDocInstructions',
];

export const KYCFields = [
  ...CommonFields,
  'parentId',
  'parentType',
  'kycProvider',
  'kycScore',
  'status',
  'kycRequest',
  'kycResponse',
];

export const UserFields = [...CommonFields, 'userGroups'];

export const PermissionFields = [...CommonFields, 'rolename', 'permissions', 'allowedFields'];

export const HistoryFields = [...CommonFields, 'parentId', 'parentType', 'oldItem', 'newItem', 'action'];

export const ConversionFields = [
  ...CommonFields,
  'parentId',
  'parentType',
  'settlementDate',
  'conversionDate',
  'estAudRevenue',
  'actualAudRevenue',
  'tradePenaltyIncome',
  'shortReference',
  'creatorContactId',
  'accountId',
  'currencyPair',
  'status',
  'buyCurrency',
  'sellCurrency',
  'clientBuyAmount',
  'clientSellAmount',
  'fixedSide',
  'amount',
  'coreRate',
  'partnerRate',
  'partnerStatus',
  'partnerBuyAmount',
  'partnerSellAmount',
  'clientRate',
  'depositRequired',
  'depositAmount',
  'depositCurrency',
  'depositStatus',
  'depositRequiredAt',
  'paymentIds',
  'unallocatedFunds',
  'uniqueRequestId',
  'midMarketRate',
  'onBehalfOf',
  // send
  'bookedBuyAmount',
  'bookedSellAmount',
  'bookedClientRate',
  'bookedMargin',
  'currencyCloudId',
  'unread',
  'audAmount',
  'complianceScore',
  'riskDetails',
  'reason',
  'legacyContractId',
  'inHouseAccount',
  'fundsReceived',
  'fullFundsReceived',
  'fullFundsReceivedDate',
  'contractSent',
  'autoSendContractNote',
  'manualSendContractNote',
  'autoPushedToCC',
  'customerNotificationCreated',
  'sendId',
  'hideFromCustomerActivity',
  'sendPaymentIds',
  'poliTransactionRef',
  'isFirstTrade',
  'markAsCompleted',
  'manualSendFundsInEmail',
  'accountManager',
  'firstName',
  'lastName',
  'businessName',
  'autoBookedDate',
  'error',
  'createdSource',
  'storeAUDRevenueInCC',
  'syncedEvent',
  'syncedAt',
  'thirdPartyPayment',
  // finance
  'financeAccount',
];

export const PaymentFields = [
  ...CommonFields,
  'parentId',
  'parentType',
  'amount',
  'beneficiaryId',
  'currency',
  'reference',
  'reason',
  'status',
  'creatorContactId',
  'paymentType',
  'paymentDate',
  'transferredAt',
  'iftiWitheld',
  'iftiWitheldDescription',
  'authorisationStepsRequired',
  'lastUpdaterContactId',
  'shortReference',
  'conversionId',
  'sendConversionId',
  'failureReason',
  'payerId',
  'payerDetailsSource',
  'paymentGroupId',
  'uniqueRequestId',
  'failureReturnedAmount',
  'ultimateBeneficiaryName',
  'purposeCode',
  'chargeType',
  'feeAmount',
  'feeCurrency',
  'currencyCloudId',
  'unread',
  'audAmount',
  'complianceScore',
  'riskDetails',
  'recipientName',
  'accountNumber',
  'iban',
  'bankName',
  'bankCode',
  'deactivateReason',
  'bicSwiftCode',
  'bsbCode',
  'sortCodeNumber',
  'inHouseAccount',
  'autoPushedToCC',
  'manualSendReceipt',
  'receiptSent',
  'sendId',
  'hideFromCustomerActivity',
  'markAsCompleted',
  'accountManager',
  'firstName',
  'lastName',
  'businessName',
  'compliancePending',
  'beneVerified',
  'beneStatus',
  'beneCurrencyCloudId',
  'customerFirstName',
  'customerLastName',
  'customerBusinessName',
  'autoBookedDate',
  'error',
  'createdSource',
  'tradeIds',
  // finance
  'financeAccount',
  'invoiceDate',
  'invoiceNumber',
];

export const IFTIFields = [
  ...CommonFields,
  'iftiType',
  'tradeId',
  'linkedPaymentId',
  'status',
  'submissionDate',
  'shortReference',
  'sendId',
  'overrideFieldsV2',
  'manualActionFieldsV2',
  'austracErrors',
  'autoOverrideFields',
  'fileName',
  'austracReference',
];

export const TransactionFields = [
  ...CommonFields,
  'parentId',
  'parentType',
  'balanceId',
  'accountId',
  'currency',
  'amount',
  'balanceAmount',
  'transactionType',
  'relatedEntityType',
  'relatedEntityId',
  'relatedEntityShortReference',
  'status',
  'reason',
  'settlesAt',
  'completedAt',
  'action',
  'currencyCloudId',
  'unread',
  'inHouseAccount',
];

export const RiskSettingFields = [
  ...CommonFields,
  'highRiskCountries',
  'highRiskCurrencies',
  'highRiskPurposes',
  'values',
  'groupCaps',
];

export const PricingPlanFields = [
  ...CommonFields,
  'status',
  'pricingPlanName',
  'pricingPlanMargin',
  'pricingPlanOutOfHoursMargin',
  'pricingPlanDefault',
];

export const PricingStructureFields = [...CommonFields, 'pricingStructureType', 'pricingStructureSettings'];

export const AffiliatesFields = [...CommonFields, 'status', 'affiliateName', 'pricingPlanId', 'affiliateEnabled'];

export const OpportunitiesFields = [
  ...CommonFields,
  'id',
  'sendId',
  'parentId',
  'parentType',
  'currencyTo',
  'currencyFrom',
  'fixedSide',
  'clientBuyAmount',
  'clientSellAmount',
  'clientRate',
  'status',
];

export const SalesOpportunityFields = [
  ...CommonFields,
  'parentId',
  'parentType',
  'currencyTo',
  'currencyFrom',
  'clientRate',
  'status',
  'expectedTradingDate',
  'confidence',
  'description',
  'assignee',
  'margin',
  'estAudRevenue',
  'fixedSide',
  'reason',
  'tradeIds',
  'amount',
  'closedDate',
];

export const LeadDistributionFields = [...CommonFields, 'field', 'rank', 'rotation', 'current', 'value'];

export const CustomerNotificationFields = [...CommonFields, 'parentId', 'parentType', 'link', 'header', 'description', 'unread'];

export const MarketingSettingsFields = [...CommonFields, 'utmSource', 'mappedAffiliateId'];

export const BulkPaymentFields = [...CommonFields, 'tradeIds', 'status', 'reason'];

export const TransferFields = [
  ...CommonFields,
  'parentId',
  'parentType',
  'sourceAccountId',
  'destinationAccountId',
  'sourceAccountName',
  'sourceAccountSendID',
  'sourceAccountType',
  'destinationAccountName',
  'destinationAccountSendID',
  'destinationAccountType',
  'amount',
  'currency',
  'status',
  'completedAt',
  'shortReference',
  'currencyCloudId',
  'reason',
];

export const IncomingFundFields = [
  ...CommonFields,
  'amount',
  'eventSource',
  'incomingFundType',
  'incomingFundProvider',
  'incomingFundDetails',
  'parentId',
  'parentType',
  'sendConversionId',
  'sendId',
  'status',
  'paymentReference',
];

export const LedgerAccountFields = [
  ...CommonFields,
  'currency',
  'metadata',
  'name',
  'code',
  'description',
  'ledgerId',
  'ledgerAccountId',
  'normalBalance',
];

export const InternalAccountFields = [
  ...CommonFields,
  'currency',
  'metadata',
  'name',
  'code',
  'partyName',
  'partyAddress',
  'connectionId',
  'internalAccountId',
];

export const VirtualAccountFields = [
  ...CommonFields,
  'currency',
  'metadata',
  'name',
  'code',
  'parentId',
  'internalAccountId',
  'virtualAccountId',
  'routingAccountName',
  'accountDetails',
  'routingDetails',
  'creditLedgerAccountId',
  'debitLedgerAccountId',
];

export const coconutType2Fields = (type) => {
  const mapping = {
    [CoconutType.Retail]: RetailFields,
    [CoconutType.Corporate]: CorporateFields,
    [CoconutType.TrustedAPIRegistration]: TrustedAPIRegistrationFields,
    [CoconutType.TrustedAPIQuote]: TrustedAPIQuoteFields,
    [CoconutType.TransactionalAPIQuote]: TransactionalAPIQuoteFields,
    [CoconutType.Registration]: RegistrationFields,
    [CoconutType.Beneficiary]: BeneficiaryFields,
    [CoconutType.Lead]: LeadFields,
    [CoconutType.Note]: NoteFields,
    [CoconutType.Task]: TaskFields,
    [CoconutType.Document]: DocumentFields,
    [CoconutType.Lookup]: LookupFields,
    [CoconutType.User]: UserFields,
    [CoconutType.Permission]: PermissionFields,
    [CoconutType.Setting]: SettingFields,
    [CoconutType.History]: HistoryFields,
    [CoconutType.KYC]: KYCFields,
    [CoconutType.RateAlert]: RateAlertFields,
    [CoconutType.Payment]: PaymentFields,
    [CoconutType.IFTI]: IFTIFields,
    [CoconutType.Conversion]: ConversionFields,
    [CoconutType.Transaction]: TransactionFields,
    [CoconutType.ComplianceNote]: ComplianceNoteFields,
    [CoconutType.RiskSetting]: RiskSettingFields,
    [CoconutType.SMR]: SMRFields,
    [CoconutType.Notification]: NotificationFields,
    [CoconutType.PricingPlan]: PricingPlanFields,
    [CoconutType.Affiliate]: AffiliatesFields,
    [CoconutType.Opportunity]: OpportunitiesFields,
    [CoconutType.CustomerNotification]: CustomerNotificationFields,
    [CoconutType.LeadDistribution]: LeadDistributionFields,
    [CoconutType.MarketingSettings]: MarketingSettingsFields,
    [CoconutType.PricingStructure]: PricingStructureFields,
    [CoconutType.BulkPayment]: BulkPaymentFields,
    [CoconutType.Transfer]: TransferFields,
    [CoconutType.SalesOpportunity]: SalesOpportunityFields,
    [CoconutType.IncomingFund]: IncomingFundFields,
    [CoconutType.LedgerAccount]: LedgerAccountFields,
    [CoconutType.VirtualAccount]: VirtualAccountFields,
  };
  return mapping[type];
};

const getType = (variables) => {
  let type = '';
  if (variables.input) {
    if (variables.input.type) {
      ({ type } = variables.input);
      if (variables.input.type.eq) {
        type = variables.input.type.eq;
      }
    }
  }
  if (variables.filter) {
    if (variables.filter.type) {
      ({ type } = variables.filter);
      if (variables.filter.type.eq) {
        type = variables.filter.type.eq;
      }
    }
  }
  if (variables.type) {
    ({ type } = variables);
    if (variables.type.eq) {
      type = variables.type.eq;
    }
  }
  return type;
};

export const graphqlOperationEx = (query, variables, desiredFields) => {
  const allowedFields = Cache.getItem('allowedFields');

  let fields = [];
  const type = getType(variables);

  if (!desiredFields && type) {
    if (variables.input) {
      fields = MutationResponseFields;
    } else if (allowedFields && allowedFields[type] && allowedFields[type].read && allowedFields[type].read !== 'all') {
      fields = allowedFields[type].read;
    } else {
      fields = coconutType2Fields(type);
    }
  } else {
    fields = desiredFields;
  }

  if (!fields || !fields.length) {
    return { query, variables };
  }

  const updatedVariables = { ...variables };

  if (variables.input) {
    const input = { ...variables.input };
    if (allowedFields) {
      const isCreate = input.createdBy != null;
      if (allowedFields[type]) {
        const inputFields = isCreate ? allowedFields[type].create : allowedFields[type].update;
        if (inputFields && inputFields !== 'all') {
          for (let i = 0; i < Object.keys(variables.input).length; i++) {
            const key = Object.keys(variables.input)[i];
            if (!inputFields.includes(key)) {
              delete input[key];
            }
          }
        }
      }
    }
    // replace blank fields by null
    const keys = Object.keys(input);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (typeof input[key] === 'string' && !input[key]) {
        input[key] = null;
      }
    }
    updatedVariables.input = input;
  }

  const queryFields = fields.join('\n');
  const beginIndex = query.indexOf('firstField');
  const endIndex = query.indexOf('lastField') + 'lastField'.length;
  const newQuery = query.substr(0, beginIndex) + queryFields + query.substr(endIndex);
  return { query: newQuery, variables: updatedVariables };
};
